<div class="carousel">
  <div class="carousel__container">
    <div
      class="carousel__items"
      [style.transform]="'translateX(' + -currentIndex() * (getCardWidth() + getCardGap()) + 'px)'"
      (touchstart)="onTouchStart($event)"
      (touchmove)="onTouchMove($event)"
      (touchend)="onTouchEnd($event)"
      (mousedown)="onMouseDown($event)"
      (mousemove)="onMouseMove($event)"
      (mouseup)="onMouseUp($event)"
      (mouseleave)="onMouseLeave()"
    >
      @for (item of items; track item) {
        <div class="carousel__item">
          <ng-container
            [ngTemplateOutlet]="itemTemplate"
            [ngTemplateOutletContext]="{ $implicit: item }"
          ></ng-container>
        </div>
      }
    </div>
  </div>

  @if (showArrows && isDesktopViewport() && totalPages() > 1 && hasItems()) {
    <div class="carousel__indicators">
      <button
        class="carousel__indicator carousel__indicator--left"
        [class.carousel__indicator--disabled]="isFirstPage()"
        [disabled]="isFirstPage()"
        (click)="previousPage()"
        aria-label="Página anterior"
      >
        <span class="mdn-Icon-esquerda mdn-Icon--md" aria-hidden="true"></span>
      </button>

      <button
        class="carousel__indicator carousel__indicator--right"
        [class.carousel__indicator--disabled]="isLastPage()"
        [disabled]="isLastPage()"
        (click)="nextPage()"
        aria-label="Próxima página"
      >
        <span class="mdn-Icon-direita mdn-Icon--md" aria-hidden="true"></span>
      </button>
    </div>
  }
</div>
